import React from 'react';
import InviteRow from './InviteRow';
import {
  ChevronIcon, KebabGlyph, UserPlusGlyph, MaterialGlyph,
} from './icons';

const GroupedMaterialCard = ({
  material,
  unitUpper,
  stepPrefix,
  expanded,
  onToggleExpand,
  selectedIds,
  onToggleRow,
  onToggleAllInCard,
  onInviteToThis,
  onRevokeRow,
  onCardKebab,
}) => {
  const rows = material.rows || [];
  const counts = material.status_counts || {};
  const canRevoke = Boolean(material.can_revoke);
  // Selection is keyed by material + audience so the same person appearing under
  // two materials is tracked independently.
  const selectKey = (row) => `${material.id}:${row.audience_id}`;
  const rowKeys = rows.map(selectKey);
  const allSelected = rowKeys.length > 0 && rowKeys.every((key) => selectedIds.has(key));

  return (
    <div className="ma-card">
      <div className="ma-card__header">
        <button
          type="button"
          className="ma-card__chevron ma-icon-btn"
          onClick={() => onToggleExpand(material.id)}
          aria-label={expanded ? 'Collapse' : 'Expand'}
          aria-expanded={expanded}
        >
          <ChevronIcon className={`ma-chevron${expanded ? ' ma-chevron--open' : ''}`} />
        </button>

        <span className="ma-card__icon"><MaterialGlyph /></span>

        <span className="ma-card__title">{material.name}</span>

        <span className="ma-tag ma-tag--steps">{material.step_count} {unitUpper}</span>
        <span className="ma-tag ma-tag--users">{material.users_count} users</span>

        <span className="ma-card__summary">
          <span className="ma-dot ma-dot--completed" /> {counts.completed || 0} completed
          <span className="ma-dot ma-dot--in-progress" /> {counts.in_progress || 0} in progress
          <span className="ma-dot ma-dot--not-started" /> {counts.not_started || 0} not started
        </span>

        <span className="ma-card__actions">
          <button type="button" className="ma-btn ma-btn--ghost ma-btn--sm" onClick={() => onInviteToThis(material)}>
            <UserPlusGlyph /> Invite to this
          </button>
          <button type="button" className="ma-icon-btn" onClick={(e) => onCardKebab(e, material)} aria-label="Card actions">
            <KebabGlyph />
          </button>
        </span>
      </div>

      {expanded && (
        <div className="ma-card__body">
          {rows.length === 0 ? (
            <div className="ma-card__no-rows">No one has accessed this {stepPrefix ? 'path' : 'walkthrough'} yet.</div>
          ) : (
            <>
              <div className="ma-row ma-row--head">
                <div className="ma-row__check">
                  <input
                    type="checkbox"
                    checked={allSelected}
                    onChange={() => onToggleAllInCard(rowKeys, !allSelected)}
                    aria-label="Select all in this card"
                  />
                </div>
                <div className="ma-row__user">USER</div>
                <div className="ma-row__progress">PROGRESS</div>
                <div className="ma-row__step">CURRENT STEP</div>
                <div className="ma-row__status">STEP STATUS</div>
                <div className="ma-row__kebab" />
              </div>

              {rows.map((row) => (
                <InviteRow
                  key={row.audience_id}
                  row={row}
                  stepPrefix={stepPrefix}
                  selected={selectedIds.has(selectKey(row))}
                  onToggleSelect={() => onToggleRow(selectKey(row))}
                  canRevoke={canRevoke}
                  onRevoke={() => onRevokeRow(material.id, row.audience_id)}
                />
              ))}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default GroupedMaterialCard;
